import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseDeleteTemplate1Request, UseDeleteTemplate1Data } from "@api/@types/consent";

export const useDeleteTemplate1 = createApiMutation<UseDeleteTemplate1Data, UseDeleteTemplate1Request>({
  mutationFn: (req) => apiClientManager.apis.consent.deleteTemplate1(req as UseDeleteTemplate1Request),
});

export type { UseDeleteTemplate1Request, UseDeleteTemplate1Data } from "@api/@types/consent";
